import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta:{
      title: '兴趣使然の无名小站。'
    }
  },
  {
    path: '/tools',
    name: 'Tools',
    component: () => import('../views/tools.vue'),
    meta:{
      title: 'TOOL/工具'
    }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
    meta:{
      title: 'ABOUT/关于'
    }
  },
  {
    path: '*',
    name: 'nf',
    component: () => import(/* webpackChunkName: "about" */ '../views/nf.vue'),
    meta:{
      title: '好像走丢了0w0'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
